"use client";

import { useState } from "react";
import { Heading } from "@/components/ui/typography";
import Image from "next/image";
  import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import { MinusIcon, PlusIcon } from "lucide-react";
const faqs = [
  {
    id:"1",
    question: "Can I open a real business bank account for my HK company?",
    answer: <><p><span className="font-bold text-white">Yes</span>. Hong Kong companies can open legitimate business accounts with both traditional banks and international fintech providers.</p>

<p>Approval depends on business model, customer geography, payment flow clarity, and compliance profile. We prepare applications so founders apply with the strongest approval positioning possible.</p></>,
  },
  {
    id:"2",
    question: "Which banks work for foreign-operated HK companies?",
    answer:
      "Several fintech providers and selected international banks support HK companies depending on risk profile and documentation quality.",
  },
  {
    id:"3",
    question: "Can I open an account without visiting Hong Kong?",
    answer:<><span className="text-white font-bold">Yes,</span> many fintech providers allow remote onboarding depending on your business structure and compliance checks.</>
      ,
  },
  {
    id:"4",
    question: "Will Stripe, PayPal, and Wise accept my HK company?",
    answer:<><span className="font-bold text-white">Yes,</span> but approval depends on business activity, website quality, and documentation clarity.</>,
  },
  {
    id:"5",
    question: "How do I pay myself from the HK company?",
    answer:
      "You can pay yourself via salary, dividends, or director fees depending on your structure and tax planning.",
  },
];

export default function FaqAccordion({ heading = "Banking" }: { heading?: string } = {}) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-black rounded-2xl border border-white/10 p-6 md:p-10 lg:p-12">


      {/* ACCORDION */}
      <div className="flex flex-col md:gap-[64px] gap-[32px] max-w-[1200px] mx-auto bg-[#0f1218] border border-white/10 rounded-lg md:p-[48px] p-[20px]">
      {/* HEADER */}
      <div className="text-center flex flex-col gap-[20px]">
        <Heading as="h2" variant="sectionCentered">
          {heading}
        </Heading>

        <p className="text-white/60 text-[16px] md:text-[18px] max-w-[750px] mx-auto">
          Accounts, processors, and how money actually flows through the structure.
        </p>
      </div>

       <Accordion type="single" collapsible className="flex flex-col gap-8">
            {faqs.map((faq,index) => (
              <AccordionItem
                key={index}
                value={faq.id}
                className="flex flex-col items-start gap-4 px-4 md:px-6 py-2 rounded-xl overflow-hidden border-b border-white/10 data-[state=open]:rounded-[12px]
  data-[state=open]:border
  data-[state=open]:border-white/10
  data-[state=open]:bg-[#161a22]"
              >
                <AccordionTrigger className="flex items-center gap-3 md:gap-4 w-full hover:no-underline [&[data-state=open]>.plus-icon]:hidden [&[data-state=closed]>.minus-icon]:hidden">
                  <span className="flex-1 text-left font-inter text-sm md:text-base tracking-[-0.32px] leading-6 md:leading-7 font-[600] whitespace-pre-line">
                    {faq.question}
                  </span>
                  <PlusIcon className="plus-icon w-4 h-4 md:w-5 md:h-5 flex-shrink-0" />
                  <MinusIcon className="minus-icon w-4 h-4 md:w-5 md:h-5 flex-shrink-0" />
                </AccordionTrigger>

                <AccordionContent>
                  <p className="text-xs md:text-sm text-white/70 leading-5 md:leading-6">
                    {faq.answer}
                  </p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

      </div>
    </section>
  );
}